
import React, { useState, useEffect, useRef } from 'react';
function DescriptionBox({ children }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const boxWidth = windowWidth < 768 ? '80%' : '480px';

  return (
    <div
      style={{
        width: boxWidth,
        margin: '20px auto',
        padding: '15px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
      }}
    >
      {children}
    </div>
  );
}

// SideNav 컴포넌트 (봉안당, 평장묘, 수목장)
function SideNav({ activeSection }) {
  const bonganRef = useRef(null);
  const pyeongRef = useRef(null);
  const sumokRef = useRef(null);
  const locationRef = useRef(null);
  const [indicatorStyle, setIndicatorStyle] = useState({ top: 0, height: 0 });
  
  const updateIndicator = () => {
    let ref = null;
    if (activeSection === 'bongan') {
      ref = bonganRef.current;
    }
    else if (activeSection === 'pyeongjangmyo') {
      ref = pyeongRef.current;
    }
    else if (activeSection === 'sumokjang') {
      ref = sumokRef.current;
    } 
    else if (activeSection === 'location') {
      ref = locationRef.current;
    } 
    if (ref) {
      setIndicatorStyle({
        top: ref.offsetTop,
        height: ref.offsetHeight,
      });
    }
  };
  
  useEffect(() => {
    updateIndicator();
  }, [activeSection]);
  
  useEffect(() => {
    window.addEventListener('scroll', updateIndicator);
    return () => window.removeEventListener('scroll', updateIndicator);
  }, []);
  
  return (
    <div className="side-nav">
      <div className="nav-indicator" style={indicatorStyle}></div>
      <a ref={bonganRef} href="#bongan" className={`nav-link ${activeSection === 'bongan' ? 'active' : ''}`}>
        봉안당
      </a>
      <a ref={pyeongRef} href="#pyeongjangmyo" className={`nav-link ${activeSection === 'pyeongjangmyo' ? 'active' : ''}`}>
        봉안묘
      </a>
      <a ref={sumokRef} href="#sumokjang" className={`nav-link ${activeSection === 'sumokjang' ? 'active' : ''}`}>
        평장묘
      </a>
      <a ref={locationRef} href="#location" className={`nav-link ${activeSection === 'location' ? 'active' : ''}`}>
        오시는 길
      </a>
    </div>
  );
}

// CarouselContent 컴포넌트 (봉안당, 수목장)
function CarouselContent({ title, description, images }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);
   // images(또는 title)가 바뀔 때마다 인덱스 리셋
   useEffect(() => {
    setCurrentIndex(0);
    setFade(true);
  }, [images]); // or [title]
  const changeSlide = (newIndex) => {
    // 페이드 아웃
    setFade(false);
    setTimeout(() => {
      setCurrentIndex(newIndex);
      // 페이드 인
      setFade(true);
    }, 500);
  };

  return (
    <div
      className="carousel-content"
      style={{ maxWidth: '800px', margin: '0 auto' }}
    >
      <div className="carousel-header">
        <h3 className="carousel-title">{title}</h3>
      </div>

      <div
        className="carousel"
        style={{
          position: 'relative',
          overflow: 'hidden',
          height: '300px',
          opacity: fade ? 1 : 0,
          transition: 'opacity 0.5s ease-in-out'
        }}
      >
        <img
          src={images[currentIndex]}
          alt={`${title} slide`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
          }}
        />
      </div>

      {/* ●●● 도트 네비게이션 */}
      <div
        className="carousel-dots"
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '12px',
          gap: '8px'
        }}
      >
        {images.map((_, idx) => (
          <button
            key={idx}
            onClick={() => changeSlide(idx)}
            aria-label={`Go to slide ${idx + 1}`}
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              border: 'none',
              cursor: 'pointer',
              background: idx === currentIndex ? '#D4AF37' : '#ccc',
              padding: 0
            }}
          />
        ))}
      </div>

      {/* 설명 박스 */}
      <DescriptionBox>
        {description.split('\n').map((line, idx) => (
          <React.Fragment key={idx}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </DescriptionBox>
    </div>
  );
  
}
// 평장묘 콘텐츠 컴포넌트
function PyeongJangMyoContent() {
  const [activeType, setActiveType] = useState('개인평장묘');
  const types = ['개인평장묘', '부부평장묘(원앙 A)', '부부평장묘(원앙 B)','가족평장묘'];
  
  // 예시 콘텐츠 데이터 (이미지 경로 및 설명은 실제 상황에 맞게 수정)
  const contentData = {
    '개인평장묘': {
      description: '아산 메모리얼 파크는 무엇보다\n편안한 휴식을 제공하기 위해 제작되었습니다.\n동시에, 제례음식을 올릴 수 있으며\n헌화도 드릴 수 있는 실용성도 갖추었습니다.\n가격도 저렴하여 가장 합리적인 선택의 개인묘입니다.',
      images: ['/img/pyeongjangmyo1.jpg','/img/pyeonjangSNG1.jpg','/img/pjP1.jpg','/img/Pyongjang1.jpg']
    },
    '부부평장묘(원앙 A)': {
      description: '한국인의 정서에 맞게\n한옥의 곡선과 진석의 멋을 살린\n심플하면서 우아한 외관과\n부부의 합장을 손쉽게 할수 있도록\n안치석과 묘비석을 분리한\n과학석 설계를 접목시킨 고품격 부부묘',
      images: ['/img/pyeong_coupleA1.jpg', '/img/pyeong_coupleA2.jpg']
    },
    '부부평장묘(원앙 B)': {
      description: '아름다운 삶을 살다가신 부부의\n애틋한 마음과 가족의 마음을\n대자연 속에 품격 높게\n아름다운 공간에 안치하여\n평안과 휴식을 드리도록 담백하게 꾸몄습니다.\n부부의 연을 오랫동안 이어가듯\n원형을 그대로 오랜세월 유지할 수 있는\n심플한 석조주고 합장형 부부묘입니다',
      images: ['/img/pyeongjangmyo.jpg', '/img/bubuB2.jpg','/img/bubu2.jpg']
    },
    '가족평장묘': {
      description: '아름다운 삶을 살아가신 가족의 소중한 인연과 \n그리운 마음을 담아 자연 속에 조화롭게 마련한 \n 가족 합장형 평장묘입니다.\n간결하고 담백한 석조를 사용하여\n오랜 세월 변함없이 편안하고 품격 있게\n추모의 시간을 함께할 수 있도록 꾸몄습니다.\n가족의 따뜻한 정을 언제까지나 간직할 수 있는\n평안과 휴식의 공간입니다.',
      images: ['/img/familyPyeonjang.jpg']
    },
    
  };
  
  const { description, images } = contentData[activeType];
  
  return (
    <div className="pyeong-content">
      <div className="type-buttons">
        {types.map((type) => (
          <button 
            key={type}
            className={`type-button ${activeType === type ? 'active' : ''}`}
            onClick={() => setActiveType(type)}
          >
            {type}
          </button>
        ))}
      </div>
      <CarouselContent title={activeType} description={description} images={images} />
    </div>
  );
}

function PyeongJangMyoContent2() {
  const [activeType, setActiveType] = useState('가족봉안묘');
  const types = ['가족봉안묘','부부봉안묘'];
  
  // 예시 콘텐츠 데이터 (이미지 경로 및 설명은 실제 상황에 맞게 수정)
  const contentData = {
   
    '가족봉안묘': {
      description: '전통의 한옥 처마를\n감각적으로 디자인한 특허출원 가족묘입니다.\n가족묘 뿐만 아니라\n가문까지 한 대를 이루고 있다는\n결집을 보여주는 고품격 가족 가문 봉안묘입니다.\n규모에 비해 관리가 쉽고\n합리적 유지비 절감으로\n가족단위와 가문묘로 많이 찾고있습니다.',
      images: ['/img/24familyBongan.jpg',,'/img/familyBongan.jpg', '/img/familyBongan2.jpg','/img/familyBongan3.jpg','/img/familyBongAn4.jpg','/img/FamilyBongAn5.jpg']
    },
    '부부봉안묘': {
      description: '부부의 사랑을\n영원히 간직할 수 있는\n부부형 봉안묘입니다.\n부부의 연을 오랫동안 이어가듯\n원형을 그대로 오랜세월 유지할 수 있는\n심플한 석조주고 합장형 부부묘입니다',
      images: ['/img/bubuBongAn.jpg']
    }
    
  };
  
  const { description, images } = contentData[activeType];
  
  return (
    <div className="pyeong-content">
      <div className="type-buttons">
        {types.map((type) => (
          <button 
            key={type}
            className={`type-button ${activeType === type ? 'active' : ''}`}
            onClick={() => setActiveType(type)}
          >
            {type}
          </button>
        ))}
      </div>
      <CarouselContent title={activeType} description={description} images={images} />
    </div>
  );
}
function NaverMap() {
  const initMap = () => {
    const mapOptions = {
      center: new window.naver.maps.Point(126.9867204, 36.6561498),
      zoom: 16,
    };
    const map = new window.naver.maps.Map('map', mapOptions);

    // 마커 생성
    const marker = new window.naver.maps.Marker({
      position: new window.naver.maps.Point(126.9867204, 36.6561498),
      map: map,
    });

    // InfoWindow 생성하여 장소 이름 표시
    const infoWindow = new window.naver.maps.InfoWindow({
      content: '<div style="padding:10px; font-size: 14px; color: #000;">충남 아산시 송악면 외암로 55-15</div>',
      borderWidth: 0,
    });
    infoWindow.open(map, marker);

    // 지도 유형 변경 컨트롤 생성 (폼 너비 600px 기준, 좌우 중앙)
    const mapTypeContainer = document.createElement('div');
    mapTypeContainer.className = 'map-type-container';
    mapTypeContainer.style.position = 'absolute';
    mapTypeContainer.style.top = '10px';
    mapTypeContainer.style.left = '50%';
    mapTypeContainer.style.transform = 'translateX(-50%)';
    mapTypeContainer.style.width = '600px';
    mapTypeContainer.style.zIndex = '1000';

    const types = [
      { id: 'NORMAL', label: '일반' },
      { id: 'SATELLITE', label: '위성' },
      { id: 'HYBRID', label: '혼합' },
    ];

    types.forEach(type => {
      const btn = document.createElement('input');
      btn.type = 'button';
      btn.id = type.id;
      btn.value = type.label;
      if (type.id === 'NORMAL') {
        btn.classList.add('control-on');
      }
      btn.style.marginRight = '5px';

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (map.getMapTypeId() !== window.naver.maps.MapTypeId[type.id]) {
          map.setMapTypeId(window.naver.maps.MapTypeId[type.id]);
          const allBtns = mapTypeContainer.getElementsByTagName('input');
          for (let i = 0; i < allBtns.length; i++) {
            allBtns[i].classList.remove('control-on');
          }
          btn.classList.add('control-on');
        }
      });
      mapTypeContainer.appendChild(btn);
    });

    const mapContainer = document.getElementById('map');
    mapContainer.appendChild(mapTypeContainer);
  };

  useEffect(() => {
    if (!window.naver) {
      const script = document.createElement('script');
      // 클라이언트 ID를 실제 값으로 변경하세요.
      script.src = "https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=441snz440j";
      script.async = true;
      //script.crossOrigin = "anonymous";
      document.head.appendChild(script);
      script.onload = initMap;
    } else {
      initMap();
    }
  }, []);

  return (
    <div className="map-container">
    <div 
      id="map"  
      className="map-element"
    ></div>
    <h3 className="map-address">충남 아산시 송악면 외암로 55-15</h3>
    <div
  className="directions-box"
  style={{
    border: '1px solid #ccc',
    padding: '15px',
    borderRadius: '8px',
    backgroundColor: '#f7f7f7',
    maxWidth: '600px',
    margin: '30px auto', // 아랫쪽 간격 30px, 중앙정렬
  }}
>
  <p><strong>강서:</strong> 서해안 고속도로 이용시 약 1시간</p>
  <p><strong>강남:</strong> 과천봉담</p>
  <p><strong>충남도청:</strong> 약 30분</p>
  <p><strong>KTX:</strong> 천안아산역에서 자가용으로 30분 이동</p>
</div>
  
  </div>

    
  );
}
function About() {
  const [activeSection, setActiveSection] = useState('#bongan');
  
  useEffect(() => {
    const sections = document.querySelectorAll('section');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.getAttribute('id'));
          }
        });
      },
      { threshold: 0.5 }
    );
    
    sections.forEach(section => observer.observe(section));
    
    return () => observer.disconnect();
  }, []);
  
  return (
    <div className="memorial-page">
      <SideNav activeSection={activeSection} />
      <div className="memorial-content">
      <div className="spacer-medium"></div>
        <section id="bongan" className="section-container">
          <CarouselContent 
            title="봉안당" 
            description={'호텔식 프리미엄급 인테리어와 고품격 감각으로\n설계한 봉안당은 개인,부부형으로 안치 가능하며,\n 최첨단 중앙관리시스템으로\n늘 청정하고 쾌적하게 유지 관리합니다'} 
            images={['/img/BongAnDang0.jpg','/img/bongan.jpg','/img/bongan2.jpg', '/img/bongan3.jpg','/img/BongAndang4.jpg','/img/huge.jpg','/img/jr.jpg']}
          />
        </section>



        <section id="pyeongjangmyo" className="section-container">
          <PyeongJangMyoContent />
        </section>
        
        <section id="sumokjang" className="section-container">
          <PyeongJangMyoContent2></PyeongJangMyoContent2>
        </section>
        
        <section id="location" className="section-container">
          <h2 style={{ textAlign: 'center' }}>오시는 길</h2>
          <NaverMap/>
        </section>
        <div className="spacer-medium"></div>
      </div>
    </div>
  );
}
export default About;